import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { getUserTypeLogoutPath, handleLogout, shouldSkipLogoutRedirectForPath } from 'utils/logout';

/**
 * Custom hook to log out and redirect to the correct login page
 * Usage: const logoutAndRedirect = useLogoutAndRedirect();
 *        await logoutAndRedirect();
 */
const useLogoutAndRedirect = () => {
  const userData = useSelector((state) => state.user?.data);
  const location = useLocation();

  return useCallback(async () => {
    const logoutUrl = getUserTypeLogoutPath(userData?.type); // get before logout clears userData
    await handleLogout();
    if (!shouldSkipLogoutRedirectForPath(location.pathname)) {
      window.location.assign(logoutUrl);
    }
  }, [userData, location.pathname]);
};

export default useLogoutAndRedirect;
